import "@/styles/base.scss";
import React, { FC, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/features/Header/Header";
import { Footer } from "@/features/Footer/Footer";
import { useReferralStore } from "@/store/referral";
import { useVkCallback } from "@/features/auth/useVkCallback";
import cls from "./styles.module.scss";

export const App: FC = () => {
  const location = useLocation();
  useVkCallback();
  const isHomePage = location.pathname === "/";
  const isMainOrPetPage =
    isHomePage || /^\/pets\/[a-f0-9-]+$/.test(location.pathname);

  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const refCode = new URLSearchParams(location.search).get("ref")?.trim();
    if (refCode) useReferralStore.getState().setRefCode(refCode);
  }, [location.search]);

  return (
    <div
      ref={scrollRef}
      data-site-scroll
      className={`${cls.wrapper} ${isHomePage ? cls.homeBackground : ""} ${
        !isMainOrPetPage ? cls.wrapperPadding : cls.mainWrapperPadding
      }`}
    >
      <Header wrapperRef={scrollRef} />
      <div className={cls.container}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};
